<template>
  <h1>Admin</h1>
</template>

<script>
export default {};
</script>

<style></style>
